import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import {
  STATUS_DATA_TYPE,
  StatusDataUMK,
  StatusDataUMO,
} from "../../Constant/StatusData";
import FilterComponent from "../FilterComponents/FilterComponent";
import FilterTanggal from "../FilterComponents/FilterTanggal";
import FilterUnitKerja from "../FilterComponents/FilterUnitKerja";
import FilterStatus from "../FilterComponents/FilterStatus";

const SubHeaderComponent = ({
  filterText,
  setFilterText,
  handleClear,
  setSelectedStatus,
  setSelectedFilterUnitKerja,
  setSelectedFilterTanggal,
  unitKerja,
  statusDataType,
}) => {
  return (
    <Col>
      <Row>
        <Col>
          <Form className="row">
            <FormGroup className="col-3">
              <FilterTanggal
                setSelectedFilterTanggal={setSelectedFilterTanggal}
              />
            </FormGroup>
            <FormGroup className="col-6">
              <FilterUnitKerja
                setSelectedFilterUnitKerja={setSelectedFilterUnitKerja}
                unitKerja={unitKerja}
              />
            </FormGroup>
            <FormGroup className="col-3">
              <FilterStatus
                setSelectedStatus={setSelectedStatus}
                statusDataType={statusDataType}
              />
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <Row>
        <Col className="d-inline-flex justify-content-end">
          <FilterComponent
            onFilter={(e) => {
              let newFilterText = e.target.value;
              setFilterText(newFilterText);
            }}
            onClear={() => handleClear()}
            filterText={filterText}
          />
        </Col>
      </Row>
    </Col>
  );
};

export default SubHeaderComponent;
